export function generateRandomBase64(): string {
  return typeof crypto !== 'undefined' && crypto.getRandomValues
    ? btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(16))))
    : 'k74aNNuM6JBhUhPg7ti6Ug==';
}
